import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { useAuth } from "../../context/Auth";
import { useGlobalContext } from "../../context/stateContext";
import { Building2 } from "lucide-react";

const CompanySettings = () => {
  const { requestWithAuth } = useAuth();
  const { company } = useGlobalContext();

  const [companyData, setCompanyData] = useState({
    name: "",
    address: "",
    phone_number: "",
    website: "",
  });
  const [updating, setUpdating] = useState(false);

  useEffect(() => {
    if (company) {
      setCompanyData({
        name: company.name || "",
        address: company.address || "",
        phone_number: company.phone_number || "",
        website: company.website || "",
      });
    }
  }, [company]);

  const handleChange = (e) => {
    setCompanyData({ ...companyData, [e.target.name]: e.target.value });
  };

  const updateDetails = async (e) => {
    e.preventDefault();
    setUpdating(true);
    const body = JSON.stringify(companyData);
    try {
      await requestWithAuth("/company/details/", "POST", body, {
        "Content-Type": "application/json",
      });
      setUpdating(false);
      toast.success("Details Updated Successfully");
      setTimeout(() => {
        window.location.reload();
      }, 500);
    } catch (error) {
      toast.error("Failed to update details. Please try again later.");
      setUpdating(false);
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 p-6">
      <div className="max-w-4xl mx-auto">
        {/* Header */}
        <div className="mb-8">
          <div className="flex items-center gap-2 text-gray-500 text-sm mb-1">
            <span>System</span>
            <span>/</span>
            <span className="text-gray-900 font-medium">Company Settings</span>
          </div>
          <h1 className="text-3xl font-bold text-gray-900">Company Settings</h1>
        </div>

        {/* Form Card */}
        <form
          onSubmit={updateDetails}
          className="bg-white rounded-xl shadow-sm border border-gray-200"
        >
          {/* Card Header */}
          <div className="p-6 border-b border-gray-200">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-lg">
                <Building2 className="text-blue-500" size={24} />
              </div>
              <div>
                <h2 className="text-lg font-semibold text-gray-900">
                  Company Details
                </h2>
                <p className="text-sm text-gray-500">
                  Manage your organization's primary contact and location details
                </p>
              </div>
            </div>
          </div>

          {/* Form Content */}
          <div className="p-6 space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label
                  htmlFor="name"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Company Name <span className="text-red-500">*</span>
                </label>
                <input
                  type="text"
                  name="name"
                  id="name"
                  required
                  value={companyData.name}
                  onChange={handleChange}
                  placeholder="Enter company name"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
                />
              </div>

              <div>
                <label
                  htmlFor="address"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Address
                </label>
                <input
                  type="text"
                  name="address"
                  id="address"
                  value={companyData.address}
                  onChange={handleChange}
                  placeholder="Enter address"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
                />
              </div>

              <div>
                <label
                  htmlFor="phone_number"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Phone Number
                </label>
                <input
                  type="text"
                  name="phone_number"
                  id="phone_number"
                  value={companyData.phone_number}
                  onChange={handleChange}
                  placeholder="Enter phone number"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
                />
              </div>

              <div>
                <label
                  htmlFor="website"
                  className="block text-sm font-medium text-gray-700 mb-2"
                >
                  Website
                </label>
                <input
                  type="text"
                  name="website"
                  id="website"
                  value={companyData.website}
                  onChange={handleChange}
                  placeholder="Enter website URL"
                  className="w-full border border-gray-300 rounded-lg px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white"
                />
              </div>
            </div>
          </div>

          {/* Form Footer */}
          <div className="p-6 bg-gray-50 border-t border-gray-200 rounded-b-xl flex items-center justify-end">
            {!updating ? (
              <button
                type="submit"
                className="px-6 py-2.5 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 transition-colors shadow-sm"
              >
                Submit Form
              </button>
            ) : (
              <button
                type="button"
                disabled
                className="px-6 py-2.5 text-sm font-medium text-white bg-blue-400 rounded-lg cursor-not-allowed flex items-center gap-2"
              >
                <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
                Submitting...
              </button>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CompanySettings;

